import React, { useState } from "react";
import { Tab, TabList } from "@fluentui/react-components";
import WeeklyTimesheetGrid from "./components/WeeklyTimesheetGrid";
import TeamTimesheetList from "./components/TeamTimesheetList";
import WeekSelector from "./components/WeekSelector";
import styles from "./timesheet.module.scss";
import moment from "moment";

const Timesheet = () => {
  let isPM = false;
  const userRoles = JSON.parse(localStorage.getItem('roles'));
  if(userRoles){
    isPM = !!userRoles.find(r => r.type == 4 && r.isDefault);
  }
  
  const [selectedTab, setSelectedTab] = useState(isPM ? "mine" : null);
  const [showWeekend, setShowWeekend] = useState(false);
  const [currentWeek, setCurrentWeek] = useState({
    year: moment().endOf('isoWeek').year(),
    week: moment().isoWeek(),
    startDate: moment().startOf('isoWeek').toDate(),
    endDate: moment().endOf('isoWeek').toDate(),
  });

  const onTabSelect = (event, data) => {
    setSelectedTab(data.value);
  };

  const handleWeekChange = (newWeek) => {
    setCurrentWeek(newWeek);
  };

  return (
    <div className={styles.timesheetContainer}>
      <div className={styles.timesheetHeader}>
        {isPM && (
          <TabList
            selectedValue={selectedTab}
            onTabSelect={onTabSelect}
            className="DashboardTabs"
          >
            <Tab id="Mine" value="mine" className="summary-tab">
              <span className="tab-label">My Timesheets</span>
            </Tab>
            <Tab id="Team" value="team" className="timeline-tab">
              <span className="tab-label">Team's Timesheets</span>
            </Tab>
          </TabList>
        )}

        <div className={styles.headerControls}>
          <WeekSelector 
            currentWeek={currentWeek}
            onWeekChange={handleWeekChange}
            showWeekend={showWeekend}
          />
        </div>
      </div>

      <div className={styles.timesheetContent}>
        {!isPM || selectedTab === "mine" ? (
          <WeeklyTimesheetGrid
            year={currentWeek.year}
            week={currentWeek.week}
            isPM={false}
            currentWeek={currentWeek}
            onWeekChange={handleWeekChange}
            showWeekend={showWeekend}
            setShowWeekend={setShowWeekend}
          />
        ) : (
          <TeamTimesheetList
            year={currentWeek.year}
            week={currentWeek.week}
            currentWeek={currentWeek}
            onWeekChange={handleWeekChange}
            showWeekend={showWeekend}
            setShowWeekend={setShowWeekend}
          />
        )}
      </div>
    </div>
  );
};

export default Timesheet;
